<template>
  <div v-if="path" class="row">
    <!-- fluidSelectRow -->
    <div v-if="!hideTitle" class="col-12">
      <label
        v-tooltip="uniToolTipTranslation('S382', 'en-US')"
        class="label-unidato materialSelectLabel"
      >
        {{ uniTranslation(title) }}</label
      >
    </div>
    <div v-if="!hideTitle" class="col-12">
      <el-select v-model="selectedMaterial" class="materialSelect" placeholder="..." filterable>
        <el-option
          v-for="item in materialList"
          :key="item.materialID"
          v-tooltip="uniToolTipTranslation(item.description, 'en-US')"
          :label="uniTranslation(item.description)"
          :value="item.materialID"
        >
        </el-option>
      </el-select>
    </div>
    <div v-if="hideTitle" class="col-12">
      <el-select v-model="selectedMaterial" class="materialSelect" placeholder="..." filterable>
        <el-option
          v-for="item in materialList"
          :key="item.materialID"
          v-tooltip="uniToolTipTranslation(item.description, 'en-US')"
          :label="uniTranslation(item.description)"
          :value="item.materialID"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
//import materialService from "../../services/backend/materialService";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    tags: {
      type: String,
      required: true
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "S382"
    }
  },
  data() {
    return {
      path: null,
      compTitle: "",
      materialList: [],
      selectedMaterial: "",
      tagList: []
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    selectedMaterial: function(nv /*, ov*/) {
      if (
        nv != null &&
        nv != undefined &&
        this.path != null &&
        this.path != undefined &&
        this.path !== ""
      ) {
        var idg = parseInt(nv);
        this.changeProperty({
          path: this.path,
          value: idg
        });
      }
    }
  },
  mounted: function() {
    if (this.parentPath !== undefined && this.parentPath !== null && this.parentPath !== "") {
      if (this.name.substring(0, 1) === ".") {
        this.path = this.parentPath + this.name;
      } else {
        this.path = this.parentPath + "." + this.name;
      }

      this.loadMaterials();
    }
  },
  methods: {
    ...mapActions("_materialModule", ["getMaterialsListFilteredOrderedAction"]),
    ...mapActions("_prjModule", ["changeProperty"]),

    loadMaterials: function() {
      var that = this;

      if (this.tags.substring(0, 1) === ".") {
        this.tagList = jsonHelper.getProperty(that.projects, this.parentPath + that.tags);
      } else {
        this.tagList = jsonHelper.getProperty(that.projects, this.parentPath + "." + that.tags);
      }

      that.getMaterialsListFilteredOrderedAction(that.tagList).then(function(data) {
        data.forEach(element => {
          let descr = "";
          if (element.descriptionID > 0) descr = "TRNSL" + element.descriptionID;
          else descr = element.description;
          that.materialList.push({
            description: descr,
            materialID: element.materialID,
            thermalConductivitsy: element.thermalConductivity,
            density: element.density,
            price: element.price
          });
        });
        that.selectedMaterial = that.materialList[0].materialID;
      });
    }
  }
};
</script>

<style lang="scss">
.materialSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.materialSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
}
</style>
